import { useTranslation } from 'react-i18next';
import "assets/css/components/Button.scss";
import { ReactComponent as IconReset } from 'assets/images/icons/icon-reset.svg';

type ResetButtonProps = {
  onClick: () => void
};

const ResetButton = ({ onClick }: ResetButtonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <button type='button' className='button' onClick={ onClick }>
      <IconReset />
      <span>{ t('button_reset') }</span>
    </button>
  );
};

export default ResetButton;
